<template>
  <div class="contract-name">
    <!--收件箱、待签的、已结束-->
    <template v-if="applyType === 'signList'">
      <!--待签的-->
      <template v-if="signInfo.status === 0 || signInfo.status === -1">
        <!--待我签-->
        <el-tooltip
          v-if="signInfo.selfSign === 1"
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span @click="toSign(signInfo.signNo, signInfo.approveId)" :class="{'font-sty':newFont}">
            {{signInfo.name}}
          </span>
        </el-tooltip>
        <!--待ta签-->
        <el-tooltip v-else effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="toApplyDetail({ applyNo: signInfo.applyNo, signNo: signInfo.signNo })" :class="{'font-sty':newFont}">
            {{signInfo.name}}
          </span>
        </el-tooltip>
      </template>
      <!--已完成-->
      <template v-else-if="signInfo.status === 1 || signInfo.status === 4">
        <!--&lt;!&ndash;未买保险&ndash;&gt;-->
        <!--<i @click="$emit('handleInsurance')" v-if="signInfo.insureState === 0"-->
        <!--class="no insure-icon iconbaoxianchanpin iconfont"></i>-->
        <!--&lt;!&ndash;已买保险&ndash;&gt;-->
        <!--<i @click="$emit('handleInsurance')"-->
        <!--v-else-if="signInfo.insureState === 1"-->
        <!--class="yes insure-icon iconbaoxianchanpin iconfont"></i>-->
        <el-tooltip effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="toApplyDetail({ applyNo: signInfo.applyNo, signNo: signInfo.signNo })" :class="{'font-sty':newFont}">
            {{
            signInfo.name
            }}
          </span>
        </el-tooltip>
      </template>
      <!--其他情况-->
      <template v-else-if="signInfo.status === -5 || signInfo.status === 2">
        <el-tooltip effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="toApplyDetail({ applyNo: signInfo.applyNo, signNo: signInfo.signNo })" :class="{'font-sty':newFont}">
            {{
            signInfo.name
            }}
          </span>
        </el-tooltip>
      </template>
      <template v-else-if="signInfo.status === -6">
        <el-tooltip effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="$message.error('文件已过期')" :class="{'font-sty':newFont}">{{ signInfo.name }}</span>
        </el-tooltip>
      </template>
    </template>
    <template v-else-if="applyType === 'applyList'">
      <!--待签的-->
      <template v-if="signInfo.status === 0">
        <!--待我签-->
        <el-tooltip
          v-if="signInfo.selfSign === 1"
          effect="dark"
          :content="signInfo.name"
          placement="bottom-start"
        >
          <span @click="toSign(signInfo.signNo, signInfo.approveId)" :class="{'font-sty':newFont}">
            {{
            `${signInfo.name}${[17,20].includes(signInfo.row.applySignDealType) ? ` (${signInfo.row.businessNo})` : ''}`
            }}
          </span>
        </el-tooltip>
        <!--待ta签-->
        <el-tooltip v-else effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="toApplyDetail({ applyNo: signInfo.applyNo, signNo: signInfo.signNo })" :class="{'font-sty':newFont}">
            {{
            signInfo.name
            }}
          </span>
        </el-tooltip>
      </template>
      <!--已过期-->
      <template v-else-if="signInfo.status === -6">
        <el-tooltip effect="dark" :content="signInfo.name" placement="bottom-start">
          <span @click="$message.error('文件已过期')" :class="{'font-sty':newFont}">{{ signInfo.name }}</span>
        </el-tooltip>
      </template>
      <!--已完成-->
      <template v-else>
        <el-tooltip
          effect="dark"
          :content="signInfo.name || signInfo.contractName"
          placement="bottom-start"
        >
          <span @click="toApplyDetail({ applyNo: signInfo.applyNo, signNo: signInfo.signNo })" :class="{'font-sty':newFont}">
            {{
            signInfo.name || signInfo.contractName
            }}
          </span>
        </el-tooltip>
      </template>
    </template>
    <goto-auth :default="authDialog"></goto-auth>
  </div>
</template>

<script>
import SignContract from "@/assets/js/http-serve/signInfoController";
import { applyViewUrl, ApiMethods } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk, authentication } from '../../assets/js/utils/ding-env';

export default {
  name: "contractName",
  data () {
    return {
      authDialog: false
    };
  },
  props: {
    newFont:{type:Boolean},
    signInfo: {
      type: Object
    },
    applyType: {
      type: String
    },
    enterpriseSubjectType: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    /** 批量签逻辑处理 */
    batchSignInfo(signNo){
      console.log('signNo',signNo);
      ApiMethods.CertiController.batchSignUrl({signNo}).then(res=>{
        if(!res.success) return this.$message.error(res.description || '获取批量签署地址失败')
        const {ts,mid:mId,bsNo,iden,sign} =res.data;
        let router = this.$router.resolve({ 
          path: '/derong/signInfo/viewDetail', 
          query: {ts,mId,bsNo,iden,sign,applySignDealType:this.signInfo.row.applySignDealType}
        });
        let href = window.location.origin + router.href;
        // 如果是钉钉环境就走 location 不要 window.open
        isInDingTalk ? location.href = href : window.open(href,'_blank')
      })
    },
    // 前往签署
    toSign (signNo, approveId) {
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((this.signInfo.row.applyNo && this.signInfo.row.applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (this.$store.getters.authUser.identityAuth > -1) {
        // 如果是批量签，走批量签的逻辑
        if ([17,20].includes(this.signInfo.row.applySignDealType)) return this.batchSignInfo(signNo, approveId);
        this.loading = this.$loading({ lock: true });
        let new_window = ''
        if (!isInDingTalk) new_window = window.open("", "_blank");
        if ([1, 2].includes(this.enterpriseSubjectType)) {
          ApiMethods.UserApplySignController.viewUrl({
            signNo: signNo,
            corpQuery: 1,
          }).then(({ data }) => {
            let path = this.signInfo.multiFile
              ? "/applySign/toDetailMultiAnony"
              : "/applySign/toDetailAnony";
            this.loading.close();
            data.approveId = approveId;
            let router = this.$router.resolve({ path: path, query: data });
            let href = window.location.origin + router.href;
            // 如果是钉钉环境就走 location 不要 window.open
            isInDingTalk ? location.href = href : new_window.location.href = href
            // 设置token
            localStorage.setItem("JZQ_SIGN_TOKEN_KEY", data.tokenKey);
            localStorage.setItem("JZQ_SIGN_TOKEN", data.token);
          })
            .catch(err => {
              this.loading.close();
              if (!isInDingTalk) new_window.close();
              this.$confirm(err.description, "系统提示", {
                confirmButtonText: "确定",
                type: "warning"
              }).then(() => { });
            });
        } else {
          SignContract.postSignUrl(signNo)
            .then(({ data }) => {
              let path = this.signInfo.multiFile
                ? "/initiation/viewDetail"
                : "/signInfo/viewDetail";
              this.loading.close();
              data.approveId = approveId;
              let router = this.$router.resolve({ path: path, query: data });
              let href = window.location.origin + router.href;
              // 如果是钉钉环境 不要 window.open
              isInDingTalk ? this.$router.push({ path, query: data }) : new_window.location.href = href
              // 设置token
              localStorage.setItem("JZQ_SIGN_TOKEN_KEY", data.tokenKey);
              localStorage.setItem("JZQ_SIGN_TOKEN", data.token);
            })
            .catch(err => {
              this.loading.close();
              if (!isInDingTalk) new_window.close();
              this.$confirm(err.description, "系统提示", {
                confirmButtonText: "确定",
                type: "warning"
              }).then(() => { });
            });
        }
      } else {
        this.authDialog = true;
      }
    },
    // 前往合同详情
    toApplyDetail ({ applyNo, signNo }) {
      if((applyNo && applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      if (this.signInfo.row.applySignCreateType === 0 && this.signInfo.row.applySignDealType === 6) {
        return this.$message.error('该合同仅是hash保全，无法查看合同内容');
      }
      if (this.$store.getters.authUser.identityAuth > -1) {
        let param = {
          signNo: signNo,
          applyNo: applyNo,
          multiFile: this.signInfo.multiFile
        };
        this.loading = this.$loading({ lock: true });
        let newWindow = '';
        if (!isInDingTalk) newWindow = window.open();
        if ([1, 2, 3].includes(this.enterpriseSubjectType)) {
          ApiMethods.UserApplySignController.viewUrl({
            ...param,
            corpQuery: 1,
          })
            .then(({ data }) => {
              let path = this.signInfo.multiFile
                ? "/applySign/toDetailMultiAnony"
                : "/applySign/toDetailAnony";
              this.loading.close();
              data.approveId = '';
              let router = this.$router.resolve({ path: path, query: data });
              let href = window.location.origin + router.href;
              // 如果是钉钉环境就走 location 不要 window.open
              isInDingTalk ? location.href = href : newWindow.location.href = href;
            })
            .catch(err => {
              console.log('err', err);
              this.loading.close();
              if (!isInDingTalk) newWindow.close();
              this.$message.error(err.description || "无法查看该合同");
              console.error("toApplyDetail: " + JSON.stringify(err));
            });
        } else {
          applyViewUrl(param)
            .then(url => {
              this.loading.close();
              isInDingTalk ? location.href = url : newWindow.location.href = url
            })
            .catch(err => {
              console.log('err', err);
              this.loading.close();
              if (!isInDingTalk) newWindow.close();
              this.$message.error(err.description || "无法查看该合同");
              console.error("toApplyDetail: " + JSON.stringify(err));
            });
        }
      } else {
        this.authDialog = true;
      }
    }
  },
  mounted () {
  },
};
</script>

<style lang="less" scoped>
.contract-name {
  line-height: 30px;
  overflow: hidden;
  /*max-width: 60%; // 解决safari下太宽问题*/

  & > span {
    max-width: 100%;
    display: inline-block;
    line-height: 1;
    padding: 3px 0;
    vertical-align: middle;
    cursor: pointer;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-y: hidden;
    color: #290202;
    font-weight: 800;
    font-size: 16px;

    &:hover {
      border-bottom: solid 1px #ec1c1c;
      color: #ec1c1c;
    }
  }
  .font-sty{
    font-size: 14px;
    color: #606266;
    font-weight: unset;
  }

  .insure-icon {
    margin-right: 5px;
    vertical-align: middle;
    position: absolute;
    left: -20px;
    cursor: pointer;
    &.no {
      color: #ec1c1c;
    }
    &.yes {
      color: green;
    }
  }
}
.authDialog {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 40px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 2, 2, 0.65);

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
/deep/ .el-button--small:hover {
  opacity: 0.7 !important;
}
</style>



// WEBPACK FOOTER //
// components/apply-list/contractName.vue